import { useState, useEffect } from "react";
import { makeQueryString } from "utils/utils";
import { useDebouncedValue } from "./useDebouncedValue";
import { useAutoComplete } from "./useAutoComplete";
import useSWR from "swr";
import { privateGet } from "services/privateRequest";

const fetcher = async (url, dataCb) => {
    const { data } = await privateGet(url);
    return dataCb(data)
};

export const useOptions = (
    endpoint,
    dataCb
) => {
    const [searchInputValue, setSearchInputValue] = useState("");
    const debouncedSearchValue = useDebouncedValue(searchInputValue);
    const { isOpen, onHandleOpenChange } = useAutoComplete();

    const { data: options, error, isLoading } = useSWR(
        debouncedSearchValue ? makeQueryString(endpoint, { pageNumber: 1, limit: 10, search: debouncedSearchValue }) : makeQueryString(endpoint, { pageNumber: 1, limit: 10 }),
        (url) => fetcher(url, dataCb),
        { revalidateOnFocus: false, dedupingInterval: 60000 } // Add caching options
    );


    const onSearchInputValueChange = (event, newInputValue, reason) => {
        if (reason === 'input' || reason === 'clear') {
            setSearchInputValue(newInputValue);
        }
    };

    const onHandleOpenOptionsListOpenChange = (value) => {
        onHandleOpenChange(value);
    };

    useEffect(() => {
        // Trigger fetch on mount
        setSearchInputValue("");
    }, []);

    return {
        isOpen,
        options: options || [],
        isError: !!error,
        isLoading: isLoading,
        onSearchInputValueChange,
        onHandleOpenChange: onHandleOpenOptionsListOpenChange,
    };
};
